export default __webpack_public_path__ + "static/media/save.e9212f43.svg";